import { useContext, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { handleClickMenuItem, MenuIcon } from './MenuCommon';
import { getSiteCoreImagePath } from "../Common/home-common";
import { Accordion } from 'react-bootstrap';
import { use2ndLvlMenuQuery } from '../Home/Data/SitecoreDataHooks';
import { GlobalContext } from '../../contexts/GlobalContext';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';
import RelatedMenu from '../Header/RelatedMenu';
import MenuHubIcon from '../../info/Include/images/menu_hub_icon.svg';

const MobileSecondLvlMenu = ({loginLogoutHook}) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    // const { loginLogoutHook } = useContext(GlobalContext)
    const [menuLoading, menuData] = use2ndLvlMenuQuery();
    const { isPCardUser } = loginLogoutHook
    const globalContext = useContext(GlobalContext);
    const { sendAdobeEvent } = useAdobeLaunch();

    useEffect(() => {
        if (!menuLoading && menuData?.length) {
            const priorityMenu = menuData.find(menu => menu.key === "Int_Priority");
            if (priorityMenu) {
                globalContext?.setOpenCWL?.(priorityMenu);
            }
        }
    }, [menuLoading, menuData]);

    const handleOnPageChange = (url) => {
        navigate(url);
    }

    const handleClickPriorityBtn = (menu) => {
        globalContext.setIsShowPcardPanel(true);
        document.getElementById('divBetSlipNormal').classList.add('pcard-active');
        if (document.getElementsByClassName('bm-overlay')[0].style.opacity === '1') {
            document.getElementsByClassName('bm-overlay')[0].click();
        }
        document.getElementById('betslip-container').style.display = 'inherit';
        document.getElementById("divBetSlipNormal").style.left = "calc(100vw - 90vw)";
        document.getElementById("betslip-over-lay").style.left = "0";
        document.body.style.overflow = "hidden";
        const element = document.querySelector('.bottom-menu');
        element.style.zIndex = '-1'
    };

    const handleMenuClick = (e, menu) => {
        if (menu?.key === "Int_Priority") {
            sendAdobeEvent({ event: 'interaction', interaction: { eventID: 'eWin_Menu_clickHKJCPriority' } });
            if (window.sessionStorage.getItem('is_logon') !== "1") {
                handleClickPriorityBtn(menu);
                return;
            }
        }
        handleClickMenuItem(e, menu, handleOnPageChange);
    };

    const MobileIcon = ({menu}) => {
        return <div className="menu-icon">
            {menu.iconM?.src && menu.iconM?.src!=="" ? <img src={getSiteCoreImagePath(menu.iconM.src, i18n.language)} title={menu.itemName.value} /> : null}
        </div>
    }

    const Menu = () => {
        return menuData.map((menu, idx) => {
            if ( menu?.itemEnable?.value!=="1") {
                return null;
            }
            else if ( menu?.pCardEnable?.value === "1" && (sessionStorage.getItem('enableWinPoints') !== '1' || sessionStorage.getItem('pCardBlacklist') == 'Y' || sessionStorage.getItem('pCardStaff') == 'Y' || window.globalConfig.IS_EWIN2 || (window.globalConfig.IS_SPEEDBET && window.sessionStorage.getItem('is_logon') !== "1"))) {
                return null;
            }
            else if ( menu.key === "Int_Priority" && (sessionStorage.getItem('enableEwinLP') !== '1' || (globalContext?.globalState?.commonCtrl?.WhitelistedCustomerOnlyButton === true && sessionStorage.getItem('earn_and_burn_pilot') !== 'Y'))) {
                return null;
            }
            else if ( menu.key === "Int_CMLPS" && (sessionStorage.getItem('enableEwinLP') === '1' || (globalContext?.globalState?.commonCtrl?.WhitelistedCustomerOnlyButton === true && sessionStorage.getItem('earn_and_burn_pilot') !== 'Y'))) {
                return null;
            }
            else if (menu.children.filter(x=> x.itemEnable.value==="1").length > 0 ) {
                return <Accordion.Item eventKey={menu.key} key={menu.itemName.value}>
                    <Accordion.Header><MobileIcon menu={menu} />{menu.itemName.value}<MenuIcon menu={menu} /></Accordion.Header>
                    <Accordion.Body>{menuItem(menu)}</Accordion.Body>
                </Accordion.Item>;
            }
            else {
                //return <Fragment key={menu.itemName.value}><MobileIcon menu={menu} />{menu.itemName.value}<MenuIcon menu={menu} /></Fragment>
                return <div className="accordion-menu-item" key={menu.itemName.value} onClick={(e) => handleMenuClick(e, menu)}><MobileIcon menu={menu} />{menu.itemName.value}<MenuIcon menu={menu} /></div>
            }
        });
    }

    function menuItem(menu) {
        return menu.children.map((_cItem, _cIndex) => {
            if ( _cItem.itemEnable.value!=="1" ) {
                return null;
            }
            else {
                return <div onClick={(e) => handleClickMenuItem(e, _cItem, handleOnPageChange)} key={_cItem.itemName.value}>
                    <p>{_cItem.itemName.value}<MenuIcon menu={_cItem} /></p>
                </div>
            }
        });
    }

    return !menuLoading ? (
        <>
            <Accordion>
                <Menu />
            </Accordion>
            <div className="under-separator" />
            <MobileRelateMenu></MobileRelateMenu>
        </>
    ) : (
        <MobileRelateMenu></MobileRelateMenu>
    );
};

const MobileRelateMenu = () => {
    return (
       <Accordion defaultActiveKey="related-menu-key">
            <Accordion.Item eventKey="related-menu-key" key="related-menu-key">
                <Accordion.Header>
                    <div className="menu-icon">
                        <img src={MenuHubIcon} width="24" height="24" />
                    </div>
                    HKJC.com
                </Accordion.Header>
                <Accordion.Body>
                    <RelatedMenu />
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
};

export default MobileSecondLvlMenu;